import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { LogsPage } from '@/pages/logs'

export const Route = createFileRoute('/logs')({
  component: () => (
    <RequirePermission section="audit" action="view">
      <LogsPage />
    </RequirePermission>
  ),
})
